export default "__VITE_ASSET__C92FZ8_b__"